import { esES as coreESLocale, enUS as coreEnLocale } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { enUS as datePickerENLocale, esES as datepickerESLocale } from '@mui/x-date-pickers-pro/locales';

import { language } from '@/i18n';

import { CUSTOM_OVERRIDES } from './overrides';
import { CUSTOM_PALETTE } from './palette';
import { CustomTheme } from './theme.types';
import { CUSTOM_TYPOGRAPHY } from './typography';

// @ts-expect-error Allow custom (new) palette keys
export const theme: CustomTheme = createTheme(
    {
        palette: CUSTOM_PALETTE,
        typography: CUSTOM_TYPOGRAPHY,
        components: CUSTOM_OVERRIDES,
    },
    // TODO: No podemos cargar las traducciones así (de forma explícita es o en), hay que cargarlas en base al idioma seleccionado por el usuario
    language.split('-').shift() === 'es' ? datepickerESLocale : datePickerENLocale, // muix datepicker translations
    language.split('-').shift() === 'es' ? coreESLocale : coreEnLocale, // core translations
);
